import CCard from '@convenia/components/CCard'
import CTable from '@convenia/components/CTable'
import CTitle from '@convenia/components/CTitle'

export default {
  CCard,
  CTable,
  CTitle,
}
